var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocketchat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.007 512.007",
    style: {
      enableBackground: "new 0 0 512.007 512.007"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFF5AA"
    },
    cx: 256.003,
    cy: 256.003,
    r: 256.003
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE65A"
    },
    d: "M258.617,151.828c-13.8,0-27.335,1.218-40.32,3.576c-15.961-21.088-40.624-33.468-67.398-33.468 c-20.801,0-32.577,6.503-51.051,14.663l14.317,11.671c13.448,10.963,21.574,26.794,22.707,43.925 c-20.628,18.076-31.79,40.243-31.79,63.802c0,23.569,11.548,46.297,32.655,64.53c-1.311,16.853-9.408,32.389-22.666,43.197 l-14.317,11.67l135.88,135.88c6.393,0.478,12.851,0.726,19.367,0.726c70.689,0,134.686-28.651,181.012-74.973l0.014-0.014 c32.711-32.713,56.592-74.247,67.813-120.717L377.78,189.989l0,0C349.352,166.428,306.068,151.828,258.617,151.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M257.898,162.988c-78.89,0-142.842,40.613-142.842,90.713c0,21.546,11.836,41.335,31.596,56.895 c7.286,15.849,0.613,39.523-10.39,65.625c33.456,5.794,61.569-5.861,84.35-34.938c11.888,2.036,24.386,3.129,37.288,3.129 c78.89,0,142.843-40.613,142.843-90.713C400.741,203.602,336.788,162.988,257.898,162.988z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF3C3C"
    },
    d: "M258.617,151.828c-13.8,0-27.335,1.218-40.321,3.576c-15.96-21.088-40.624-33.468-67.398-33.468 c-20.801,0-32.577,6.503-51.051,14.663l14.317,11.671c13.448,10.963,21.574,26.794,22.707,43.925 c-20.628,18.076-31.79,40.243-31.79,63.802c0,23.569,11.548,46.297,32.655,64.53c-1.311,16.853-9.408,32.389-22.666,43.197 l-14.317,11.67l16.896,7.463c34.83,15.386,77.133,5.886,101.462-26.139c12.84,2.289,26.094,3.447,39.505,3.447 c83.208,0,153.536-44.856,153.536-104.169C412.152,196.647,341.771,151.828,258.617,151.828z M352.987,312.169 c-25.041,16.349-58.556,25.352-94.37,25.352c-23.848,0-39.752-3.879-49.991-6.086l-4.213,6.75 c-13.1,20.992-36.85,31.961-61.059,28.657c12.075-15.859,17.694-35.446,17.207-51.677l-0.04-5.369l-4.291-3.367 c-13.004-10.205-28.505-27.238-28.505-50.431c0-20.847,12.97-40.796,36.52-56.172c25.041-16.349,58.556-25.352,94.37-25.352 s69.328,9.004,94.37,25.352c23.551,15.376,36.52,35.324,36.52,56.172S376.537,296.793,352.987,312.169z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF3C3C"
    },
    cx: 256.349,
    cy: 256.447,
    r: 17.663
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF3C3C"
    },
    cx: 196.358,
    cy: 256.447,
    r: 17.663
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF3C3C"
    },
    cx: 316.832,
    cy: 256.447,
    r: 17.663
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketchat);
export default __webpack_public_path__ + "static/media/rocketchat.47e60c91f85feb5f932f7de0f9e33a0f.svg";
export { ForwardRef as ReactComponent };